'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002414 from "./presto.-Freemium2-F-A-Add-View$$anon$14.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002416 from "./presto.-Freemium2-F-A-Add-View$$anon$16.js";
import * as $j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse$0024 from "./presto.types$-Configure2-F-A-Freemium-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$13() {
  this.aT6 = null;
  this.aSY = null;
  this.aSZ = false;
  this.aT7 = null;
  this.aT8 = false;
  this.aTb = null;
  this.aT4 = null;
  this.aT5 = false;
  this.aT0 = null;
  this.aT1 = false;
  this.aT2 = null;
  this.aT3 = false;
  this.aT9 = false;
  this.aTa = false;
  this.aT6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aTb = "Configure2FAFreemiumResponse";
}
export { $c_Lpresto_Freemium2FAAddView$$anon$13 as $c_Lpresto_Freemium2FAAddView$$anon$13 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$13;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$13() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$13 as $h_Lpresto_Freemium2FAAddView$$anon$13 };
$h_Lpresto_Freemium2FAAddView$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aT6;
});
$p.L = (function() {
  if ((!this.aSZ)) {
    this.aSY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aSZ = true;
  }
  return this.aSY;
});
$p.O = (function() {
  if ((!this.aT8)) {
    this.aT7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aT8 = true;
  }
  return this.aT7;
});
$p.E = (function() {
  return this.aTb;
});
$p.t = (function() {
  if ((!this.aT5)) {
    this.aT4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("results", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aT5 = true;
  }
  return this.aT4;
});
$p.M = (function() {
  if ((!this.aT1)) {
    this.aT0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002414.$c_Lpresto_Freemium2FAAddView$$anon$14())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aT1 = true;
  }
  return this.aT0;
});
$p.Q = (function() {
  if ((!this.aT3)) {
    this.aT2 = new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002416.$c_Lpresto_Freemium2FAAddView$$anon$16();
    this.aT3 = true;
  }
  return this.aT2;
});
$p.w = (function() {
  if ((!this.aTa)) {
    this.aT9 = false;
    this.aTa = true;
  }
  return this.aT9;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee137) => ((p) => \u03b4scrutinee137.cGg(p)))($j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse$0024.$m_Lpresto_types$Configure2FAFreemiumResponse$())));
});
var $d_Lpresto_Freemium2FAAddView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$13, "presto.Freemium2FAAddView$$anon$13", ({
  IH: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$13 as $d_Lpresto_Freemium2FAAddView$$anon$13 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$13.js.map
